import { render, staticRenderFns } from "./VerifyShipments.vue?vue&type=template&id=fd03fd90&"
import script from "./VerifyShipments.vue?vue&type=script&lang=js&"
export * from "./VerifyShipments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports